import { Injectable } from '@angular/core';
import { CustomHttpService } from './custom-http.service';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
@Injectable({
  providedIn: 'root'
})
export class AnalyticsService {

  constructor(private http: CustomHttpService) { }

  getLeadAnalytics(params: any): Observable<any> {
    return this.http.post(environment.getLeadAnalytics, params);
  }

  
}

